import Axios from "axios"
import { Urls } from "../Urls"
import axios from "../Axios"

export const logActivity = (activity) => {
    return Axios.post(Urls.logActivity, {"user_email": sessionStorage.getItem('user_email') ? sessionStorage.getItem('user_email') : localStorage.getItem('userid'), "activity" : "Session Logging", "application":"DC_Log","accessed_from_device":"Desktop","ip":sessionStorage.getItem("ClientIP"),"session_log" : activity})
}

export const isDataDumpingAllowed = (user) => {
    return true
}

export const allowedUsers = ['sneha@logisticsnow.in', 'radhika@logisticsnow.in', 'radhika@theenterpriseforce.com', 'associate@logisticsnow.in', 'abhishek@logisticsnow.in', 'raj@logisticsnow.in', 'sneha@ln.in', 'abhishek.new@logisticsnow.in']